import 'waypoints/lib/noframework.waypoints.js';

(($) => {
  $(() => {
    // Create variables necessary for our main 'if' condition.
    const namespace = 'gram-counter';
    const $gramCounter = $(`.${namespace}`);
    const $header = $('.header');
    const $headerTop = $('.header__top');

    if ($gramCounter.length && $header.length) {
      // Create variables used throughout the functions below.
      const $toggle = $gramCounter.find(`.${namespace}__toggle`);
      const $cardsWrapper = $gramCounter.find('.gram-counter__card-wrapper');
      let $cards = $gramCounter.find('.card');

      let headerStickied = false;
      let updateTimeout;
      let resizeTimeout;
      let gramCounterHeight = $gramCounter.first().outerHeight(true);
      let headerHeight = $header.get(0).clientHeight;
      let headerTopHeight = $headerTop.get(0).clientHeight;
      let isResizing = false;

      // Apply the necessary classes to Gram Counter elements
      // based on whether the header is currently sticky or not.
      // Imported and fired within header.js.
      const updateGramCounterStyles = (action = null) => {
        if (!$gramCounter || !action ) return;

        let mqlXl = window.matchMedia("(min-width: 1200px)");

        if ('on' === action) {
          if (!$gramCounter.hasClass('gram-counter--sticky')) {
            if (updateTimeout) {
              clearTimeout(updateTimeout);
            }

            if (mqlXl.matches) {
              $cardsWrapper.fadeTo( 0, 0 );
            }
            $gramCounter.addClass('shadow-sm');
            $gramCounter.addClass('gram-counter--sticky');

            if (mqlXl.matches) {
              updateTimeout = setTimeout(() => {
                $cardsWrapper.fadeTo( 200, 1 );
              }, 200);
            }
          }
        } else if ('off' === action) {
          if ($gramCounter.hasClass('gram-counter--sticky')) {
            if (updateTimeout) {
              clearTimeout(updateTimeout);
            }

            if (mqlXl.matches) {
              $cardsWrapper.fadeTo( 0, 0 );
            }
            $gramCounter.removeClass('shadow-sm');
            $gramCounter.removeClass('gram-counter--sticky');

            if (mqlXl.matches) {
              updateTimeout = setTimeout(() => {
                $cardsWrapper.fadeTo( 200, 1 );
              }, 200);
            }

          }
        }
      }

      // Remove the 'collapsed' class when we scroll back to the top.
      // Imported and fired within header.js.
      const updateToggleStyles = (action = null) => {
        if (!action) return;
        // In case card references have changed via cart-updater behaviour.
        $cards = $gramCounter.find('.card');
        const collapsedInSession = sessionStorage.getItem('toggle_is_collapsed');
        if ('on' === action && 'true' === collapsedInSession) {
          $cards.fadeTo(0,0);
          $gramCounter.addClass(`${namespace}--collapsed`);
        } else if ( 'off' === action ) {
          let mqlXl = window.matchMedia("(min-width: 1200px)");
          if (mqlXl.matches ) {
            $cards.fadeTo(200,1);
            $gramCounter.removeClass(`${namespace}--collapsed`);
          } else {
            if ('false' === collapsedInSession) {
              $cards.fadeTo(200,1);
              $gramCounter.removeClass(`${namespace}--collapsed`);
            }
          }
        }
      }

      // Fade in the Gram Counter (after its styles may have been adjusted by
      // whether the header is sticky or not).
      setTimeout(() => {
        $gramCounter.removeClass('d-none opacity-0 visibility-hidden');
      }, 500);

      // Toggle code:
      if ($toggle.length) {
        // Handle click (collapsing/un-collapsing).
        $toggle.on('click', (e) => {
          e.stopImmediatePropagation();
          let collapsedInSession = sessionStorage.getItem('toggle_is_collapsed');
          let nextSessionStorage = 'true' === collapsedInSession ? false : true;

          sessionStorage.setItem('toggle_is_collapsed', nextSessionStorage);

          if (true === nextSessionStorage) {
            updateToggleStyles('on');
          } else if (false === nextSessionStorage) {
            updateToggleStyles('off');
          }
        })
      }

      // Create waypoint to fix the Gram Counter.
      new Waypoint({
        element: $headerTop.get(0),
        handler(direction) {
          if (isResizing === false) {
            if (direction === 'down') {
              updateGramCounterStyles('on');
              updateToggleStyles('on');

              $gramCounter.first().css({'position': 'fixed', 'top': `${headerHeight}px`});
              $gramCounter.next().css({'margin-top': `${gramCounterHeight}px`});
            }
            if (direction === 'up') {
              updateGramCounterStyles('off');
              updateToggleStyles('off');
              $gramCounter.first().css({'position': 'static', 'top': 'initial'});
              $gramCounter.next().css({'margin-top': '0'});
              setTimeout(() => {
                gramCounterHeight = $gramCounter.first().outerHeight(true);
              }, 100);
            }
          }
        },
        offset: function() {
          return (-1 * headerTopHeight);
        },
      });

      // Init function to correctly layout things on, e.g., load and window resize.
      const init = () => {
        gramCounterHeight = $gramCounter.first().outerHeight(true);
        headerHeight = $header.get(0).clientHeight;
        headerTopHeight = $headerTop.get(0).clientHeight;

        if ($header.hasClass('header--sticky') && false === headerStickied) {
          updateToggleStyles('on');
          updateGramCounterStyles('on');
          headerStickied = true;
        } else if (!$header.hasClass('header--sticky') && true === headerStickied) {
          updateToggleStyles('off');
          updateGramCounterStyles('off');
          headerStickied = false;
        }
        Waypoint.refreshAll();
      }

      $(window).on('resize', () => {
        // Wait for the window to be 'done' resizing.
        isResizing = true;
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          isResizing = false;
          init();
        }, 500);
      });

      // `$(document).on('ready', foobar())` was not firing correctly.
      $(document).ready(() => {
        init();
      })

    }
  });
})(jQuery);
